import { ReactNode } from 'react';
import { AccountingConnectionType, accountingSystemConfig } from 'shared';

import { env } from '../../common/lib/env';
import { Button } from '../../common/Atoms/Button';
import connectQBOButton from '../assets/QuickBooks-connect-button/connect-to-quickbooks-tall-default_2x.png';

import { XeroConnectButtonBlue } from './XeroConnectButtonBlue';

// Providers with brand mandated connect buttons, anything else gets a plain button
const brandedButtons: Partial<Record<AccountingConnectionType, ReactNode>> = {
  XERO: <XeroConnectButtonBlue />,
  QBO: (
    <img width={ `245px` }
      style={ { width: `245px`, maxWidth: `none` } }
      src={ connectQBOButton } />
  ),
};

export function AccountingConnectButton({ type }: { type: AccountingConnectionType }) {
  const { displayName, connectSlug } = accountingSystemConfig[type].provider;

  if (!connectSlug) {
    return null;
  }

  return (
    <a href={ `${env.apiUrl}/connect/${connectSlug}` }>
      { brandedButtons[type] ?? <Button>{ `Connect to ${displayName}` }</Button> }
    </a>
  );
}
